import { BillingPageLayout } from './components/BillingPageLayout';
import { PlanChooser } from './components/PlanChooser';
import { BILLING_STRINGS } from './constants/billing-strings';

const COPY = BILLING_STRINGS.PURCHASE;

/**
 * Choosing a plan (FR-39, MYN-111).
 *
 * The first of two steps before Stripe: compare plans here, then choose seats,
 * apply a promo code and see the total on the review step (Sprint 7 QA: seats
 * and promo used to sit above every plan, with no total, so extra seats seemed
 * to cost nothing).
 *
 * The navbar's "Get an Issue Report" lands here (FR-128).
 *
 * No visible page header: the client asked for the page to show only the
 * Issue Report card (UX round 3, StartupAdminPatty Y5). The title stays as a
 * screen-reader-only heading so the page still has an h1.
 */
export function PurchasePage() {
  return (
    <BillingPageLayout>
      <h1 className="sr-only">{COPY.TITLE}</h1>
      <PlanChooser />
    </BillingPageLayout>
  );
}
